// export const orderSource = [
//   { key: 1, value: '普通零客' },
//   { key: 2, value: '验货宝' },
//   { key: 3, value: 'API' }
// ]

// export const CustomSigningType = [
//   { key: 1, value: '非签约商家', min: 100, max: 100 },
//   { key: 2, value: '非签约商家（学员）', min: 85, max: 85 },
//   { key: 3, value: '签约商家', min: 70, max: 70 },
//   { key: 4, value: '签约商家（学员）', min: 60, max: 60 },
//   { key: 5, value: 'A签约商家', min: 65, max: 65 },
//   { key: 6, value: 'AA签约商家', min: 60, max: 60 },
//   { key: 7, value: 'AAA签约商家', min: 55, max: 55 },
//   { key: 8, value: '签约平台商家', min: 0, max: 100 }
// ]

// export const appraisalType = [
//   { key: 1, value: '个人意见书' },
//   { key: 2, value: '商家防伪扣' }
// ]

// export const AppraisalResult = [
//   { key: 1, value: '鉴定通过' },
//   { key: 3, value: '鉴定不通过' },
//   { key: 10, value: '拒绝鉴定' }
// ]

// export const orderStatus = [
//   { key: 1, value: '待发货' },
//   { key: 2, value: '已发货' },
//   { key: 3, value: '已收货' },
//   { key: 4, value: '初审' },
//   { key: 5, value: '初审2' },
//   { key: 6, value: '初审3' },
//   { key: 7, value: '复审' },
//   { key: 8, value: '审核' },
//   { key: 9, value: '待买家确认' },
//   { key: 10, value: '待回寄' },
//   { key: 11, value: '已回寄' },
//   { key: 15, value: '完成' },
//   { key: 16, value: '已过期' }
// ]

// export const operateType = [
//   { key: 1, value: '初审', isAuto: false, prop: '', propLevel: 'firstAppraisalLevel' },
//   { key: 2, value: '初审2', isAuto: true, prop: 'secondAppraisalAuto', propLevel: 'secondAppraisalLevel' },
//   { key: 3, value: '初审3', isAuto: true, prop: 'thirdAppraisalAuto', propLevel: 'thirdAppraisalLevel' },
//   { key: 4, value: '复审', isAuto: true, prop: 'ackAppraisalAuto', propLevel: 'ackAppraisalLevel' }
// ]

export const userStatusList = [{ name: '未使用', status: 1 }, { name: '轻微使用痕迹', status: 2 }, { name: '明显使用痕迹', status: 3 }]

export const CustomType = [{ key: 1, value: '个人' }, { key: 2, value: '商家' }]

export const rechargeType = [
  { key: 1, value: '现金充值' },
  { key: 2, value: '现金支付' },
  { key: 3, value: '现金冻结' },
  { key: 4, value: '现金冻结确认消费' },
  { key: 5, value: '现金冻结取消' },
  { key: 6, value: '退款' }
]

export const TagApplyStatus = [{ value: '已申请', key: 1 }, { value: '已发放', key: 2 }, { value: '不予通过', key: 9 }]

export const VendorType = [{ value: '个人', key: 2 }, { value: '商家', key: 1 }]

export const CustomTagApplyStatus = [{ value: '待确认', key: 1 }, { value: '已确认', key: 2 }, { value: '待发放', key: 0 }]

export const OrderUploadStatus = [
  { label: '全部', value: null, type: null },
  { label: '执行中', value: 0, type: null },
  { label: '全部失败', value: -1, type: 'danger' },
  { label: '全部成功', value: 1, type: 'success' },
  { label: '部分成功', value: 2, type: 'warning' },
  // { label: '待审核', value: 5, type: 'warning' },
  // { label: '审核不通过', value: 9, type: 'danger' },
  { label: '已取消', value: 10, type: 'danger' }
]

export const CommomStatus = [
  { value: 1, label: '启用' },
  { value: 0, label: '禁用' }
]
